module.exports = __webpack_public_path__ + "img/brand2.606350ea.png";